import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { StatusChip } from "@/components/Badges";

export default function MyEscalations() {
  const { t } = useLang();
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/escalations").then((r) => setItems(r.data)); }, []);
  return (
    <div>
      <div className="eyebrow">{t("nav_my_escalations")}</div>
      <h1 className="text-2xl font-bold mb-4" style={{ color: "var(--brand-navy)" }}>{t("escalations")}</h1>
      <div className="space-y-2">
        {items.map((e) => (
          <div key={e.id} data-testid={`esc-row-${e.id}`} className="hag-surface p-3 flex items-center gap-2 flex-wrap">
            <span className={`status-chip ${e.class === "Critical" ? "pace-red" : e.class === "Major" ? "pace-amber" : "pace-none"}`}>{t(`class_${e.class.toLowerCase()}`)}</span>
            <StatusChip status={e.status} />
            <div className="text-sm flex-1">{e.description}</div>
            <div className="text-xs text-[#7C8E9E]">{new Date(e.raised_at).toLocaleString()}</div>
          </div>
        ))}
        {items.length === 0 && <div data-testid="empty-esc" className="text-sm text-[#7C8E9E]">{t("no_escalations")}</div>}
      </div>
    </div>
  );
}
